import { type StructuredText as StructuredTextType } from 'datocms-structured-text-utils'
import React, { type ReactElement } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import PersonsEpisode from '@/components/models/episode/persons-episode/persons-episode'
import StructuredTextDefault from '@/components/structured-text/structured-text-default'
import Tags from '@/components/tags/tags'
import routes from '@/internal/constants/routes'

import * as styles from './main-episode.module.scss'

type MainEpisodeProps = {
  episode: Queries.EpisodeQuery['datoCmsPctEpisode']
}
const MainEpisode = ({ episode }: Readonly<MainEpisodeProps>): ReactElement => {
  if (episode == null) {
    return <></>
  }
  const { tags, content, urlProvider, authors, topic, guest } = episode
  const transistorEpisodeId = urlProvider?.split('/')[4]
  const hostPersons = (authors ?? []).reduce<Queries.PersonDetailFragment[]>(
    (acc, author) => {
      if (author?.person != null) {
        acc.push(author.person)
      }
      return acc
    },
    []
  )
  const guestPersons = (guest ?? []).reduce<Queries.PersonDetailFragment[]>(
    (acc, author) => {
      if (author?.person != null) {
        acc.push(author.person)
      }
      return acc
    },
    []
  )

  return (
    <Container as="section">
      <Row className={`${styles.marginTopVideo} mb-4`}>
        <Col lg="9" className="mx-auto">
          <iframe
            width="100%"
            height="180"
            frameBorder="no"
            scrolling="no"
            src={routes.podcastPlayerPrefix + transistorEpisodeId}
          />
        </Col>
      </Row>
      <Row>
        <Col lg="9" className="mx-auto">
          <StructuredTextDefault
            content={content as unknown as StructuredTextType}
          />
          <Tags tags={tags} topic={topic} />
          <PersonsEpisode persons={guestPersons} type="Guest" />
          <PersonsEpisode persons={hostPersons} type="Host" />
        </Col>
      </Row>
    </Container>
  )
}
export default MainEpisode
